import { css, html, nothing, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import 'src/library/editors/elements/d-select-dropdown';
import { NewsSlideBase } from 'src/content/screens/news-slide-base';
import { t } from 'src/i18n';

@customElement('d-news-slide-nrk')
export class DNewsSlideNrk extends NewsSlideBase {
  static readonly styles = [
    ...NewsSlideBase.styles,
    css`
      :host {
        color: white;
      }
      .image-wrapper {
        background: black;
      }
      .background-image {
        filter: blur(0.5cqw);
        width: 100%;
        height: auto;
        opacity: 0.6;
        transform: scale(1.1);
      }
      .front-image {
        width: 68.5cqw;
        aspect-ratio: 16/9;
      }
      .logo {
        width: 7.5cqi;
      }
      .title {
        width: 92.5cqw;
        height: 17.7cqw;
        padding: 2cqw 2cqw 1.5cqw 3cqw;
      }
      .description {
        width: 31.5cqw;
        padding: 2cqw 2cqw 3cqw 3cqw;
        background-color: hsla(0, 0%, 0%, 0.4);
      }
    `,
  ];
  render(): TemplateResult<1> {
    if (this.item) {
      return html`
        <div class="image-wrapper">
          ${this.item.imgUrl ? html`<img class="background-image" src="${this.item.imgUrl}" />` : nothing}
          <img class="logo" src="https://gfx.nrk.no/ZQa7ZMdrmZjV5uzIGBzl-wpLfS5fQrnZ2A7K39YPcXrA" />
          <div class="title">${this.item.title}</div>
          <div class="description">${this.shortenContent(this.item.description, 240)}</div>
          ${this.item.imgUrl ? html`<img class="front-image" src="${this.item.imgUrl}" />` : nothing}
          ${this.edit
            ? html`
                <div class="controllers-position">
                  <div class="controllers">
                    <d-select-dropdown
                      controller
                      label="${t('screens.newsSlide.itemsCountLabel')}"
                      .options=${this.countOptions}
                      .value=${this.slide.itemsCount + ''}
                      @value-changed=${(e: CustomEvent<{ value: string }>) => this.onCountChanged(e)}
                    ></d-select-dropdown>
                    <d-select-dropdown
                      controller
                      label="${t('screens.newsSlide.itemDurationLabel')}"
                      .options=${this.durationOptions}
                      .value=${this.slide.itemDuration + ''}
                      @value-changed=${(e: CustomEvent<{ value: string }>) => this.onDurationChanged(e)}
                    ></d-select-dropdown>
                  </div>
                </div>
              `
            : html`<div class="overlay"></div>`}
        </div>
      `;
    }
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-news-slide-nrk': DNewsSlideNrk;
  }
}
